module.exports = "<div\n  class=\"modelpic\"\n  ng-style=\"{backgroundImage: 'url(' + $root.BASE_CONTENT + model.image + ')'}\"\n>\n  <a ui-sref=\"model({modelId: model.id})\" ng-if=\"$root.isMember\"\n    ><img ng-src=\"{{ $root.BASE_CONTENT + model.image }}\" alt=\"{{ model.name }}\"\n  /></a>\n</div>\n<div class=\"model_details\">\n  <h3>\n    <a ui-sref=\"model({modelId: model.id})\" ng-if=\"$root.isMember\">{{\n      model.name\n    }}</a>\n    <a ng-if=\"!$root.isMember\">{{ model.name }}</a>\n  </h3>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/modelblock.html
// module id = 197
// module chunks = 0